import { render, staticRenderFns } from "./ShipmentsReceiptsManagement.vue?vue&type=template&id=addfbde6&scoped=true"
import script from "./ShipmentsReceiptsManagement.vue?vue&type=script&lang=js"
export * from "./ShipmentsReceiptsManagement.vue?vue&type=script&lang=js"
import style0 from "./ShipmentsReceiptsManagement.vue?vue&type=style&index=0&id=addfbde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addfbde6",
  null
  
)

export default component.exports